import { OnInit, Component, ViewChild, ElementRef } from '@angular/core';
import { FilterService } from '../../../../services/filter.service';
import { LogisticsService } from '../../../../services/logistics.service';
import { MenuService } from '../../../../services/menu.service';
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl, FormControl } from '@angular/forms';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { AuthService } from '../../../../services/auth.service';
import { SectorFilter } from '../../../../model/sector-filter';
import { FilterCompleteService } from '../../../../filter-complete/filter-complete';
import { ValidateAutoCompleteSelect } from '../../../../validators/autocomplete-select.validator';
import { BehaviorSubject } from 'rxjs';
import { StudyReportBatchEditInfo, StudyReportBatchItemInfo } from '../../../../model/logistics/study-report';


@Component({
  selector: 'send-individual-study-report-logistics',
  templateUrl: './send-individual-study-report-logistics.component.html',
  styleUrls: ['./send-individual-study-report-logistics.component.css']
})
export class SendIndividualStudyReportLogisticsComponent implements OnInit {

  loadingAction: boolean;
  loading: boolean;
  form: FormGroup;
  sectors: SectorFilter[];
  filterCompleteSectorSend: FilterCompleteService<SectorFilter>;
  filterCompleteSectorReceiver: FilterCompleteService<SectorFilter>;
  @ViewChild('newProtocol', {static: false}) newProtocol: ElementRef;
  @ViewChild('sectorReceiver', {static: false}) sectorReceiver: ElementRef;
  displayColumns = ['Protocol', 'buttons'];
  dataSource = new BehaviorSubject<AbstractControl[]>([]);

  constructor(private filterService: FilterService
    , private menuService: MenuService
    , private formBuilder: FormBuilder
    , private notificationToastService: NotificationToastService
    , private authService: AuthService
    , private logisticsService: LogisticsService) {
    this.menuService.setMenuTitle('Logística', 'envío individual informes');
    this.clear();
    this.filterCompleteSectorSend = new FilterCompleteService<SectorFilter>([], this.fStudyReportBatch.SectorSend);
    this.filterCompleteSectorReceiver = new FilterCompleteService<SectorFilter>([], this.fStudyReportBatch.SectorReceiver);
  }

  get filteredSectorReceiverOptions() { return this.filterCompleteSectorReceiver ? this.filterCompleteSectorReceiver.filteredOptions : []; }
  get filteredSectorSendOptions() { return this.filterCompleteSectorSend ? this.filterCompleteSectorSend.filteredOptions : []; }
  get f() { return this.form.controls; }
  get fStudyReportBatch() { return this.studyReportBatchForm.controls; }
  get studyReportBatchForm() { return <FormGroup>this.form.get('StudyReportBatch'); }
  get studyReportItemsForm() { return <FormArray>this.form.get('StudyReportBatchItems'); }

  displayProtocol(index: number): string {
    return this.studyReportItemsForm.controls[index].value.Protocol;
  }

  onDeleteProtocol(index: number): void {
    this.studyReportItemsForm.removeAt(index);
    this.dataSource.next(this.studyReportItemsForm.controls);
  }

  async ngOnInit() {
    try {
      this.loading = true;
      this.sectors = await this.filterService.getSectorsFilter();
      this.filterCompleteSectorSend = new FilterCompleteService<SectorFilter>(this.sectors, this.fStudyReportBatch.SectorSend);
      this.filterCompleteSectorReceiver = new FilterCompleteService<SectorFilter>(this.sectors, this.fStudyReportBatch.SectorReceiver);
      const batchEditInfo = await this.logisticsService.getStudyReportBatchEditInfo(this.authService.getSectorId());
      const sectorSend = this.sectors.find(x => x.Id == batchEditInfo.StudyReportBatch.SectorSend.Id);


      this.form.patchValue({
        NewProtocol: batchEditInfo.NewProtocol
      });

      this.studyReportBatchForm.patchValue({
        Description: batchEditInfo.StudyReportBatch.Description
        , Name: batchEditInfo.StudyReportBatch.Name
        , CreateDate: batchEditInfo.StudyReportBatch.CreateDate
        , DeliveryDate: batchEditInfo.StudyReportBatch.DeliveryDate
        , ReceptionDate: batchEditInfo.StudyReportBatch.ReceptionDate
        , DeleteDate: batchEditInfo.StudyReportBatch.DeleteDate
        , UpdateDate: batchEditInfo.StudyReportBatch.UpdateDate
        , Deleted: batchEditInfo.StudyReportBatch.Deleted
        , Id: batchEditInfo.StudyReportBatch.Id
        , BatchStateId: batchEditInfo.StudyReportBatch.BatchStateId
        , SectorSend: sectorSend
        , SectorReceiver: null
        , CreateUser: batchEditInfo.StudyReportBatch.CreateUser
        , UpdateUser: batchEditInfo.StudyReportBatch.UpdateUser
        , DeleteUser: batchEditInfo.StudyReportBatch.DeleteUser
      });

      setTimeout(() => this.sectorReceiver.nativeElement.focus(), 0);


    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Logística');
    } finally {
      this.loading = false;
    }
  }

  async addProtocol() {
    try {
      if (!this.form.invalid) {
        this.loadingAction = true;
        const items = await this.logisticsService
          .studyReportBatchItemAddProtocoloIndividualSend(<StudyReportBatchEditInfo>this.form.getRawValue());
        this.form.controls.OrderBatchItems = this.formBuilder.array([]);
        if (items) {
          items.forEach((item) => {
            
            if (item.Warning) {
              this.notificationToastService
                .info('El protocolo tiene informes con el siguiente error: ' + item.Warning, 'Logistica');
            }

            this.addStudyReportBatchItem(item)
          });
        }
        this.form.patchValue({
          NewProtocol: null
        });

      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Logística');
    } finally {
      this.loadingAction = false;
      setTimeout(() => this.newProtocol.nativeElement.focus(), 0);
    }
  }

  async send() {
    try {
      if (this.studyReportItemsForm.length > 0) {
        this.loadingAction = true;
        if (await this.logisticsService.studyReportBatchIndividualSend(<StudyReportBatchEditInfo>this.form.getRawValue())) {
          this.notificationToastService.success('Se han enviado los informes correctamente', 'Logística');
          await this.cancel();
        } else {
          this.notificationToastService.error('No se ha podido enviar el lote de informes', 'Logística');
        }
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Logística');
    } finally {
      this.loadingAction = false;
    }
  }

  async cancel() {
    this.clear();
    await this.ngOnInit();
  }

  addStudyReportBatchItem(studyReportBatchItemInfo: StudyReportBatchItemInfo): void {

    const row = this.formBuilder.group({
      Protocol: [studyReportBatchItemInfo.Protocol],
      Id: [studyReportBatchItemInfo.Id],
      StudyReportId: [studyReportBatchItemInfo.StudyReportId],
      StudyReportBatchId: [studyReportBatchItemInfo.StudyReportBatchId],
    });

    this.studyReportItemsForm.push(row);
    this.dataSource.next(this.studyReportItemsForm.controls);
  }

  clear(): void {
    this.form = this.formBuilder.group({
      StudyReportBatch: this.formBuilder.group({
        Description: [''],
        Deleted: [''],
        DeliveryDate: [''],
        ReceptionDate: [''],
        Id: [''],
        BatchStateId: [''],
        Name: [''],
        SectorSend: new FormControl({ value: '', disabled: true }, [Validators.required, ValidateAutoCompleteSelect]),
        SectorReceiver: ['', [Validators.required, ValidateAutoCompleteSelect]]
      }),
      StudyReportBatchItems: this.formBuilder.array([]),
      NewProtocol: ['', Validators.required]
    });
  }

}
